import React from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button
  } from '@chakra-ui/react'
import { CustomModalProps } from '../../../types/overlay';

export default function CustomModal({
    isOpen,
    modalType,
    ...props
}: CustomModalProps) {
    return (
        <Modal isOpen={isOpen} onClose={props.onCloseFn} size={props.size} id={props.id}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader 
                    borderBottomWidth={'1px'} 
                    borderBottomStyle='solid' 
                    borderBottomColor={'gray.200'}
                    marginBottom={'2'}
                    paddingBottom='6'
                >
                    {props.headerTitle}
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    {props.children}
                </ModalBody>

                {props.isFooter && (
                    <ModalFooter
                        marginTop={'2'}
                        marginBottom={'2'}
                        borderTopWidth={'1px'} 
                        borderTopStyle='solid' 
                        borderTopColor={'gray.200'}
                    >
                        <Button variant='ghost' size={'sm'} mr={3} onClick={props.onCloseFn}>
                            {props.footerSecondaryBtnLabel || "Cancel"}
                        </Button>
                        <Button 
                            variant='solid' 
                            size={'sm'} 
                            colorScheme={modalType === 'delete' ? 'red' : 'blue'} 
                            isDisabled={props.footerPrimaryBtnDisabled}
                            onClick={props.footerPrimaryBtnFn}
                        >
                            {props.footerPrimaryBtnLabel}
                        </Button>
                    </ModalFooter>
                )}
            </ModalContent>
      </Modal>
    )
}
